import { styled } from '@linaria/react';

import { uiToken } from '~/shared/constants/uiToken';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  margin: 0;
`;

export const Description = styled.p`
  color: ${uiToken.color.system.error};
`;
